import React from "react";
import { Route, Routes } from "react-router-dom";
import NotFound404 from "../../pages/error/NotFound404";
import AdminDashboard from "../../pages/dashboard/AdminDashboard";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/dashboard" element={<AdminDashboard />} />
      <Route path="/*" element={<NotFound404 />} />
    </Routes>
  );
};

export default AdminRoutes;
